import { useAuth0 } from "@auth0/auth0-react";
import React from "react";

export const LoginButtonMobile = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = async () => {
    await loginWithRedirect({
      appState: {
        returnTo: "/dashboard",
      },
      authorizationParams: {
        prompt: "login",
        screen_hint: "signup",
      },
    });
  };

  return (
    <button className="button__login" onClick={handleLogin}>
      sign in
    </button>
  );
};
